import moment from "moment";

/** The POD images urls will be loaded till 30 mins from the meter off time */
export const MaxPollingDuration = moment.duration(30, "minutes");

/** The timer value for polling the POD image urls is 30 secs */
export const PollingIntervalInMillis = 30000;
